export default __webpack_public_path__ + "static/media/record_alberta-critical-care.8caa340b.png";